<template>
  <div class="question">
    <div class="m">
      <div class="tit">
        <h2>常见问题</h2>
      </div>
      <div class="question_content">
        <div class="question_content_l">
          <div class="question_content_li" v-for="item,index in list" @mouseover="changeActive('first'+index)">
            <div class="question_tit">
              <i class="iconfont q">Q</i>
              <h3 :class="{active:show==='first'+index}">{{item.name}}</h3>
            </div>
            <transition name="slide-fade">
              <div
                v-if="show ==='first'+index"
                class="question_answer"
              >{{common.filterHtml(item.content).substring(0,120)+'...'}}<router-link  :to="{name: item.route}" class="link">详情</router-link></div>
            </transition>
          </div>

        </div>
        <div class="question_content_r">
          <img :src="c1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import c1 from "@/assets/img/home/c1.png";
export default {
  data() {
    return {
      c1: c1,
      show: "first0",
	    list: [
        {name: '学校管理员入驻流程', content: '学校管理员入驻流程', route: 'help_detail'},
        {name: '导师入驻流程', content: '导师入驻流程', route: 'help_detail2'},
        {name: '毕业生入驻流程', content: '毕业生入驻流程', route: 'help_detai3'},
      ]
    };
  },
  created(){
    // this.getData();
  },
  methods: {
    changeActive(tmp) {
      this.show = tmp;
    },
	  getData(){
		  let params = {
			  type: 'ActiveTypeHelpGDInnovate',
			  pageNo: 0,
        pageSize: 4,
        sort: 'SortDefault'
		  }
		  this.postAxios(`/host${api.getActivities}`,params).then(res=>{
			  if(res.error['err_code']!==0)return;
			  this.list = res.obj.list;
		  })
	  }
  }
};
</script>

<style lang="scss" scoped>
.question {
  background: #f9f9fc;
  padding-top: 49px;
  .tit {
    h2 {
      color: #4b5062;
      font-size: 28px;
      font-weight: bold;
    }
  }
  .question_content {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
  }
  .question_content_l {
    flex-basis: 676px;
  }
  .question_content_li {
  }
  .question_tit {
    display: flex;
    align-items: center;
    height: 32px;
    line-height: 32px;
    /*cursor: pointer;*/
    h3 {
      font-size: 16px;
      color: #4b5062;
    }
    h3.active{
      font-weight:bold;
    }
    .q{
      width: 21px;
      height: 13px;
      font-size: 6px;
      line-height: 13px;
      text-align: center;
      background-color: #ff733c;
      color: #ffffff;
      position: relative;
      vertical-align: middle;
    }
    .q:before{
      content: '';
      width: 5px;
      height: 7px;
      background-color: #ff733c;
      position: absolute;
      bottom: -5px;
      left: 0px;
    }
    .q:after{
      content: '';
      width: 5px;
      height: 7px;
      background-color: #fff;
      position: absolute;
      bottom: -8px;
      left: 2px;
      transform:rotate(45deg);
    }
  }
  .question_answer {
    height: 84px;
    line-height: 24px;
    padding: 3px 0 12px 33px;
    font-size: 14px;
    color: #9fa4b1;
    box-sizing: border-box;
  }
  .question_content_r {
  }
  .slide-fade-enter-active {
    transition: all 0.2s ease-out;
  }
  .slide-fade-leave-active {
    transition: all 0.1s ease-out;
  }
  .slide-fade-enter {
    opacity: 1;
  }
  .slide-fade-leave-to {
    height: 0;
    opacity: 0;
  }
  .link{
    color: #3282FF;
    margin-left: 10px;
  }
}
</style>
